import script from "./PermissionChecker.vue?vue&type=script&lang=js"
export * from "./PermissionChecker.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__